import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Slice } from '@shapeable/types';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { MailchimpTownTeamEmbed } from '../elements/mailchimp-town-team-embed';

const cls = classNames('slice-mailchimp-town-team-embed');

export type SliceMailchimpTownTeamEmbedProps = Classable & HasChildren & {
  entity?: Slice;
};

type ContainerProps = {};

const ContainerStyles = breakpoints({
  base: css``,
});

const My = {
  Container: styled(MailchimpTownTeamEmbed)<ContainerProps>`${ContainerStyles}`,
};

export const SliceMailchimpTownTeamEmbed: Shapeable.FC<SliceMailchimpTownTeamEmbedProps> = (props) => {
  const { className } = props;

  return (
    <My.Container className={cls.name(className)} />
  )
};

SliceMailchimpTownTeamEmbed.cls = cls;
